import _ from "lodash";
import React, { useState, useEffect } from "react";

import { Route, Switch, Redirect, useRouteMatch } from "react-router-dom";
import { Error400 } from "views/pages";
import IntlMessages from "util/intlMessages";
import ContentTable from "./Table";
import { PageTitle } from "components/standart";
import AddAccount from "./Add";
import ContentInfo from "./Info";
import { path } from "./init";

const OpenAISchedules = (props) => {
  const { url, path } = useRouteMatch();
  const { breadCrumbs } = props;

  breadCrumbs.push({
    title: <IntlMessages id="OpenAI.Schedules" />,
    url,
    actions: [<AddAccount />],
  });

  return (
    <Switch>
      <Route exact path={`${path}`}>
        <PageTitle {...breadCrumbs} />

        <ContentTable />
      </Route>

      <Route path={`${path}/schedule_:scheduleId`}>
        <ContentInfo {...{ breadCrumbs }} />
      </Route>

      <Route component={Error400} />
    </Switch>
  );
};

OpenAISchedules.path = path;

export default OpenAISchedules;
